import React from 'react';
import { ppData } from '../../configs/ppData.config';
import { handleize } from '../../../../utils/handleize';
import { LABEL_HOT_DEAL } from '../../constants/labelValues';
export const Labels = () => React.createElement(React.Fragment, null,
    ppData.labels?.includes(LABEL_HOT_DEAL) === true &&
        React.createElement("span", { key: LABEL_HOT_DEAL, className: "pos:a z:2 l:0 t:16 t:20:xl-up lh:normal fz:18 fz:20:xl-up py:2 px:8 bg:accent-red color:white bdrs:tr:12 bdrs:br:12" }, LABEL_HOT_DEAL.toUpperCase()),
    ppData.labels?.reduce((arr, label) => (label === LABEL_HOT_DEAL || arr.length > 1
        ? arr
        : [
            ...arr,
            React.createElement("span", { key: label, className: `pos:a z:2 l:0 b:14 b:20:xl-up fz:10 fz:20:md-up fz:14:lg-up fz:20:xl-up flag:label flag:${handleize(label)}`, style: arr.length > 0 ? { transform: `translateY(-${105 * arr.length}%)` } : undefined }, label.toUpperCase())
        ]), []));
